import { render } from "./MainTypeView.vue?vue&type=template&id=2c726433&scoped=true"
import script from "./MainTypeView.vue?vue&type=script&lang=js"
export * from "./MainTypeView.vue?vue&type=script&lang=js"

import "./MainTypeView.vue?vue&type=style&index=0&id=2c726433&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c726433"]])

export default __exports__